{
  "name": "clerk-simulator",
  "private": true,
  "version": "0.1.0",
  "type": "module",
  "packageManager": "pnpm@11.15.1",
  "engines": {
    "node": ">=22"
  },
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "deploy": "node scripts/deploy.ts",
    "cf-typegen": "wrangler types",
    "typecheck": "tsc -b",
    "lint": "eslint . --max-warnings=0",
    "lint:fix": "eslint . --fix",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "test": "vitest run",
    "test:watch": "vitest",
    "check": "pnpm run typecheck && pnpm run lint && pnpm run format:check && pnpm run test",
    "prepare": "lefthook install",
    "test:e2e": "playwright test",
    "og": "node scripts/og-image.ts",
    "deploy:wip": "pnpm run build && wrangler deploy --message \"WIP (uncommitted working tree)\"",
    "smoke": "node scripts/smoke.ts"
  },
  "devDependencies": {
    "@cloudflare/vite-plugin": "^1.62.3",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.63.0",
    "@types/node": "^26.6.3",
    "eslint": "^10.11.0",
    "eslint-config-prettier": "^10.1.8",
    "globals": "^17.13.0",
    "happy-dom": "^20.14.5",
    "lefthook": "^2.1.15",
    "prettier": "^3.9.9",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.71.0",
    "vite": "^8.3.2",
    "vitest": "^5.0.3",
    "wrangler": "^4.145.0"
  }
}
